import { ReplayWidgetShell } from "@githits/replay-shared";
import ReplayPage from "./components/ReplayPage";

export function ReplayWidget() {
  return (
    <ReplayWidgetShell>
      <ReplayPage />
    </ReplayWidgetShell>
  );
}
